import type { LoggedInLoadingMessageKey } from '../../state'

type LoggedInLoadingMessages = {
  title: string
  description: string
}

type TranslateFn = (key: string, options?: { defaultValue?: string }) => string
type LoggedInLoadingMessageResolver = (t: TranslateFn) => LoggedInLoadingMessages

const DEFAULT_LOGGED_IN_LOADING_MESSAGES: LoggedInLoadingMessageResolver = (t) => ({
  title: '',
  description: t('summary:loggingIn'),
})

const LOGGED_IN_LOADING_MESSAGE_RESOLVERS: Record<LoggedInLoadingMessageKey, LoggedInLoadingMessageResolver> = {
  unsuitabilityQuestions: (t) => ({
    title: t('common:unsuitabilityQuestions:title', { defaultValue: '' }),
    description: t('common:unsuitabilityQuestions:description'),
  }),
  verifyIdentity: (t) => ({
    title: t('common:verifyIdentity:title', { defaultValue: '' }),
    description: t('common:verifyIdentity:description'),
  }),
}

const selectLoggedInLoadingMessageResolver = (key: string | null | undefined): LoggedInLoadingMessageResolver => {
  if (key === undefined || key === null || key === '') {
    return DEFAULT_LOGGED_IN_LOADING_MESSAGES
  }

  return LOGGED_IN_LOADING_MESSAGE_RESOLVERS[key as LoggedInLoadingMessageKey] ?? DEFAULT_LOGGED_IN_LOADING_MESSAGES
}

export function getLoggedInLoadingMessages(t: TranslateFn, key: string | null | undefined): LoggedInLoadingMessages {
  return selectLoggedInLoadingMessageResolver(key)(t)
}
